import { render, staticRenderFns } from "./DetailsForm.vue?vue&type=template&id=9d03142e&scoped=true&"
import script from "./DetailsForm.vue?vue&type=script&lang=js&"
export * from "./DetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailsForm.vue?vue&type=style&index=0&id=9d03142e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d03142e",
  null
  
)

export default component.exports